import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import ProgressBar from "./ProgressBar";

export default class PlayPause extends Phaser.GameObjects.Container {
  constructor(scene, callback) {
    super(scene);
    this.callback = callback;
    this.isPlaying = true;
  }

  init(flag) {
    this.play = this.scene.add.image(0, 0, "play");
    this.add(this.play);
    this.pause = this.scene.add.image(0, 0, "pause");
    this.add(this.pause);
    this.setPlay(flag);
    this.setListeners(true);
  }

  setListeners(lFlag) {
    if (lFlag) {
      this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(-32, -32, 64, 64), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });
      this.on("pointerdown", this.toggleState.bind(this));
    } else {
      this.removeInteractive();
      this.off("pointerdown");
    }
  }

  setPlay(flag) {
    this.isPlaying = flag;
    if (flag) {
      this.play.visible = false;
      this.pause.visible = true;
    } else {
      this.play.visible = true;
      this.pause.visible = false;
    }
  }

  toggleState() {
    if (this.isPlaying) {
      this.setPlay(false);
    } else {
      this.setPlay(true);
    }
    this.dispatch(PlayPause.EVENT_CHANGED, this.isPlaying);
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  enable(flag) {
    this.setListeners(flag);
  }
}

PlayPause.EVENT_CHANGED = "eventChanged";
